import { Route, RouteGroup } from '@billow/easy-route'
import { concat } from 'lodash'

export default concat(

  RouteGroup({
    parent: Route('/setup', '', () => import('@/views/setup/Index')),

    routes: [
      Route('/', 'account-setup', () => import(`@/views/setup/CompanyInfo`)),
      Route('user-setup', 'account-setup-step-2', () => import(`@/views/setup/UserSetup`)),
    ]
  }),
)